module.exports = __webpack_public_path__ + "img/kachel-zeitgard_ZEITGARD1.e21c2d3d.png";